import { useEffect } from "react";

export default function Proefdag() {
  useEffect(() => {
    window.location.href = "https://proefdag.babyfeeding.nl/";
  }, []);

  return null;
}